import getAPIPath from '../modules/api-location';

window.createSessionService = function(data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/session`,
    type: 'POST',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.editSessionService = function(data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/session`,
    type: 'PUT',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.deleteSessionService = function(sessionId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/session/${sessionId}`,
    type: 'DELETE',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.checkSessionExistsService = function(title, sessionId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/does-user-session-exist`,
    type: 'GET',
    data: {
      title,
      session_id: sessionId,
    },
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.getSessionDrillsService = function(sessionId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user-session?session_id=${sessionId}`,
    type: 'GET',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};



// WEBPACK FOOTER //
// ./library/js/services/session.service.js